export default "__VITE_ASSET__DaFuhtsA__"